#@import GliveBooking.Presenters.QuantityPicker
#@import GliveBooking.Views.Picker
#@import GliveBooking.Views.Quantities
#@export GliveBooking.Views.QuantityPicker

class GliveBooking.Views.QuantityPicker extends GliveBooking.Views.Picker

  module: 'glive-booking'

  presenter: GliveBooking.Presenters.QuantityPicker

  templateName: 'quantitypicker'

  contentView: GliveBooking.Views.Quantities

  attributes: ->
    'data-bhw': "#{GliveBooking.bhw}Quantities"

  styleClassName: 'quantities'
